/**
 * Meta deprecated POST_PURCHASE_UPDATE, CONFIRMED_EVENT_UPDATE and ACCOUNT_UPDATE
 * on Messenger in favor of Utility Message Templates.
 * @see https://developers.facebook.com/docs/messenger-platform/send-messages/utility-messages
 */
export const MESSENGER_MESSAGE_TAGS = ["HUMAN_AGENT"];
